import Vue from "vue";
// @ts-ignore
import Vuetable from "vuetable-2";

Vue.use(Vuetable);
